/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const filterViewListSlice = createSlice({
    name: 'filterViewList',
    initialState: initialState,
    reducers: {
        setFormData: (state, action) => {
            return action.payload;
        },
        deleteFilter: (state, action) => {
            const idToDelete = action.payload;
            return state.filter((item) => item.id !== idToDelete);
        },
    },
});

export const { setFormData, deleteFilter } = filterViewListSlice.actions;
export default filterViewListSlice.reducer;
